import authenticate from "@/auth/authenticate";

export default [
  {
    path: "/extras",
    name: "extras",
    component: () => import("@/views/global/Clear"),

    children: [
      {
        path: "platform/preview",
        name: "extras.platform.preview",
        // beforeEnter: authenticate,
        component: () => import("@/views/extras/PlatformPreview"),

      },
    ],
  },
];
